import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { maintenanceForwardingStatus } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingStatus.constant";
import { useMaintenanceForwarding } from "@/features/maintenance/features/workflows/hooks/forwardings/useMaintenanceForwarding";
import { MaintenaceWorkflowData } from "@/features/maintenance/features/workflows/types/maintenanceWorkflows.type";
import { useEffect, useMemo } from "react";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";
import { useWorkflowShowStore } from "@/features/maintenance/features/workflows/stores/workflowShowStore";

interface MaintenanceWorkflowForwardingsTabProps {
  workflow?: MaintenaceWorkflowData;
}

const MaintenanceWorkflowForwardingsTab = ({ workflow }: MaintenanceWorkflowForwardingsTabProps) => {
  const { setForwarding } = useWorkflowShowStore();

  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
    dataUpdatedAt: forwardingUpdatedAt,
  } = useMaintenanceForwarding(workflow?.current_forwarding?.id);

  const ForwardingStateComponent = useMemo(() => {
    if (!workflow?.current_forwarding?.status) {
      return false;
    }

    return maintenanceForwardingStatus[workflow?.current_forwarding?.status]?.component || false;
  }, [workflow?.current_forwarding?.status]);

  useEffect(() => {
    setForwarding(forwarding);
  }, [forwardingUpdatedAt]);

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingError?.status}
      refetchFunction={refetchForwarding}
    >
      {forwarding && ForwardingStateComponent && (
        <ForwardingStateComponent forwarding={forwarding} />
      )}

      {(!forwarding || !ForwardingStateComponent) && (
        <EmptyDataMessage className="flex-1" />
      )}
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingsTab;
